import { assign } from 'lodash'

import { BaseDto } from "./base.dto"
import { DateOfBirthDto } from "./date-of-birth.dto"
import { OrderDto } from "./order.dto"
import { PagingDto } from "./paging.dto"
import { UserDto } from "./user.dto"

export class TenantCouponCodeDto {
  id: string
  limitUsage: number
  usedCount: number
  couponCode: string
  isValid: boolean
}

export class CreateTenantCouponDto {
  khmerTitle: string
  englishTitle: string
  amount: number
  minOrder: number
  maxOrder: number
  discountType: string
  productType?: string
  startDate?: DateOfBirthDto
  endDate?: DateOfBirthDto
  limitUsage?: number
  numberOfCode?: number
  couponCode?: string
  codeType: string
  prefix?: string

  static create() {
    return new CreateTenantCouponDto()
  }
}

export class FindTenantCouponDto extends PagingDto {
  status?: string
  searchText?: string
}

export class TenantCouponDto extends BaseDto {
  khmerTitle: string
  englishTitle: string
  amount: number
  discountType: string
  productType?: string
  limitUsage: number
  status: string
  couponCodes: TenantCouponCodeDto[]
  numberOfCode: number
  codeType: string
  startDate: DateOfBirthDto
  endDate: DateOfBirthDto
  minOrder: number
  maxOrder: number
  prefix: string
  
  static create() {
    return assign(new TenantCouponDto(), {
      maxOrder: 1999.99
    })
  }
}

export class TenantCouponHistoryDto extends BaseDto {
  owner: UserDto
  total: number
  couponTotal: number
  discountAmount: number
  discountType: string
  tenantOrder: OrderDto
  couponCode: string
  tenantCoupon: TenantCouponDto

  static create() {
    return new TenantCouponHistoryDto()
  }
}

export enum DiscountStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  EXPIRED = 'expired'
}